import React from 'react';
import GlobalBreadcrumbs from '../../components/global/GlobalBreadcrumbs';
import WrapperSection from '../../components/global/WrapperSection';
import FormAddEditJobTitle from '../../components/jobTitles/FormAddEditJobTitle';
import { useParams } from 'react-router-dom';
import { useGetJobTitle } from '../../hooks/jobTitles/useGetJobTitle';
import LoadingPage from '../../components/global/LoadingPage';

const EditJobTitle = () => {
    const { id } = useParams();
    const { jobTitle, isLoading } = useGetJobTitle(id);

    if (isLoading) return <LoadingPage />;

    return (
        <WrapperSection>
            <GlobalBreadcrumbs />
            <FormAddEditJobTitle isEdit currentData={jobTitle?.data} />
        </WrapperSection>
    );
};

export default EditJobTitle;
